import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5753aee2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "window" }
const _hoisted_2 = {
  key: 0,
  class: "loader"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spin" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { ref, withDefaults, watch, onMounted } from 'vue';


import * as IDETextEditor from './IDETextEditor.vue';
import * as IDETabs from './IDETabs.vue';
import * as IDEOpenInNewWindow from './IDEOpenInNewWindow.vue';
import * as IDESideBar from './IDESideBar.vue';
import * as IDESideBarContent from './IDESideBarContent.vue';
import * as IDESideBarContentResizer from './IDESideBarContentResizer.vue';
import * as IDEViewerContentTypeUnknown from './IDEViewerContentTypeUnknown.vue';

export const EmitsOptions = {
	'sideBar:onFollowLectorActivityChanged' : IDESideBar.EmitsOptions['onFollowLectorActivityChanged'],
	'tabs:onSelectTab' : IDETabs.EmitsOptions['onSelectTab'],
	'tabs:onCloseTab' : IDETabs.EmitsOptions['onCloseTab'],
	'textEditor:onMouseDown' : IDETextEditor.EmitsOptions['onMouseDown'],
	'textEditor:onKeyDown' : IDETextEditor.EmitsOptions['onKeyDown'],
	'textEditor:onDidScrollChange' : IDETextEditor.EmitsOptions['onDidScrollChange'],
	'sideBarContent:tabs:fileSystem:onClickDirectory' : IDESideBarContent.EmitsOptions['tabs:fileSystem:onClickDirectory'],
	'sideBarContent:tabs:fileSystem:onClickFile' : IDESideBarContent.EmitsOptions['tabs:fileSystem:onClickFile'],
	'sideBarContent:tabs:download:onDownload' : IDESideBarContent.EmitsOptions['tabs:download:onDownload'],
	'sideBarContent:tabs:settings:onSettingsChanged' : IDESideBarContent.EmitsOptions['tabs:settings:onSettingsChanged'],
	'sideBarContent:onShownChanged' : (shown: boolean) => {return true;},
	'openInNewWindow' : () => {return true;},
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IDEWindow',
  props: {
    loading: { type: Boolean, default() {
		return false;
	} },
    sideBar: null,
    tabs: null,
    textEditor: null,
    sideBarContent: null,
    viewerContentTypeUnknown: null
  },
  emits: EmitsOptions,
  setup(__props: any, { expose, emit }) {

const props = __props as { loading: boolean, sideBar: {
		followLectorActivity: IDESideBar.PropsOptions["followLectorActivity"],
		videoIsPlaying: IDESideBar.PropsOptions["videoIsPlaying"],
	}, tabs: IDETabs.PropsOptions, textEditor: IDETextEditor.PropsOptions, sideBarContent: {
		shown: boolean,
		tabs: IDESideBarContent.PropsOptions["tabs"],
	}, viewerContentTypeUnknown: IDEViewerContentTypeUnknown.PropsOptions }





const IDETextEditorInstance = ref({} as InstanceType<typeof IDETextEditor.default>);
const IDESideBarContentInstance = ref<InstanceType<typeof IDESideBarContent.default>|null>(null);

expose({
	getTextEditorInstance() {
		return IDETextEditorInstance;
	},
})


function openInNewWindow() {
	emit('openInNewWindow');
}

const sideBarSelectedTab = ref<string|null>(props.sideBarContent.shown ? "fileSystem" : null);
let previousSelectedTab:string|null = 'fileSystem';
function onChangeSideBarSelectedTab(newSelectedTab:string) {
	// pokud se klika na tab, ktery uz je aktivni, tak misto toho shovat
	if (sideBarSelectedTab.value == newSelectedTab) {
		toggleSideBarContent();
	}else {
		// pokud se vybira novy tab, tak ho zmenit na novy a zajistit, ze bude obsah zobrazen
		previousSelectedTab = sideBarSelectedTab.value;
		sideBarSelectedTab.value = newSelectedTab;
		showSideBarContent();
	}
}
function toggleSideBarContent() {
	emit('sideBarContent:onShownChanged', !props.sideBarContent.shown);
}
function showSideBarContent() {
	emit('sideBarContent:onShownChanged', true);
}
watch(() => props.sideBarContent.shown, () => {
	// pokud je obsah shovany
	if (props.sideBarContent.shown == false) {
		// pokud je aktualne nejaky tab vybrany, tak si ulozit jeho hodnotu
		// a odvybrat tab
		if (sideBarSelectedTab.value != null) {
			previousSelectedTab = sideBarSelectedTab.value;
			sideBarSelectedTab.value = null;
		}
	}else {
		// pokud ma byt obsah zobrazen a aktualne neni vybrany zadny tab, tak
		// tam zobrazit ten z minule
		if (sideBarSelectedTab.value == null) {
			sideBarSelectedTab.value = previousSelectedTab;
		}
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createVNode(IDEOpenInNewWindow.default, { onOnClick: openInNewWindow }),
    _createVNode(IDESideBar.default, {
      followLectorActivity: __props.sideBar.followLectorActivity,
      videoIsPlaying: __props.sideBar.videoIsPlaying,
      onOnFollowLectorActivityChanged: _cache[0] || (_cache[0] = (...args) => emit('sideBar:onFollowLectorActivityChanged', ...args)),
      selectedTab: sideBarSelectedTab.value,
      "onUpdate:selectedTab": onChangeSideBarSelectedTab
    }, null, 8, ["followLectorActivity", "videoIsPlaying", "selectedTab"]),
    _createVNode(IDETabs.default, {
      tabsList: __props.tabs.tabsList,
      onOnSelectTab: _cache[1] || (_cache[1] = (...args) => emit('tabs:onSelectTab', ...args)),
      onOnCloseTab: _cache[2] || (_cache[2] = (...args) => emit('tabs:onCloseTab', ...args))
    }, null, 8, ["tabsList"]),
    _createVNode(IDESideBarContent.default, {
      ref_key: "IDESideBarContentInstance",
      ref: IDESideBarContentInstance,
      shown: __props.sideBarContent.shown,
      selectedTab: sideBarSelectedTab.value,
      tabs: __props.sideBarContent.tabs,
      "onTabs:fileSystem:onClickDirectory": _cache[3] || (_cache[3] = (...args) => emit('sideBarContent:tabs:fileSystem:onClickDirectory', ...args)),
      "onTabs:fileSystem:onClickFile": _cache[4] || (_cache[4] = (...args) => emit('sideBarContent:tabs:fileSystem:onClickFile', ...args)),
      "onTabs:download:onDownload": _cache[5] || (_cache[5] = (...args) => emit('sideBarContent:tabs:download:onDownload', ...args)),
      "onTabs:settings:onSettingsChanged": _cache[6] || (_cache[6] = (...args) => emit('sideBarContent:tabs:settings:onSettingsChanged', ...args))
    }, null, 8, ["shown", "selectedTab", "tabs"]),
    _createVNode(IDESideBarContentResizer.default, {
      IDESideBarContentInstance: IDESideBarContentInstance.value,
      shown: __props.sideBarContent.shown
    }, null, 8, ["IDESideBarContentInstance", "shown"]),
    _createVNode(IDETextEditor.default, _mergeProps({
      ref_key: "IDETextEditorInstance",
      ref: IDETextEditorInstance
    }, __props.textEditor, {
      onOnMouseDown: _cache[7] || (_cache[7] = (...args) => emit('textEditor:onMouseDown', ...args)),
      onOnKeyDown: _cache[8] || (_cache[8] = (...args) => emit('textEditor:onKeyDown', ...args)),
      onOnDidScrollChange: _cache[9] || (_cache[9] = (...args) => emit('textEditor:onDidScrollChange', ...args))
    }), null, 16),
    _createVNode(IDEViewerContentTypeUnknown.default, {
      filename: __props.viewerContentTypeUnknown.filename,
      hidden: __props.viewerContentTypeUnknown.hidden
    }, null, 8, ["filename", "hidden"])
  ]))
}
}

})